"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint react/no-unsafe: off */


var Timer = function Timer(_ref) {
  var at = _ref.at,
      onInterval = _ref.onInterval;
  (0, _react.useEffect)(function () {
    if (!isNaN(at)) {
      var timeout = setTimeout(function () {
        onInterval && onInterval();
      }, Math.max(0, at - Date.now()));
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [at, onInterval]);
  return false;
};

Timer.defaultProps = {
  onInterval: undefined
};
Timer.propTypes = {
  at: _propTypes.default.number.isRequired,
  onInterval: _propTypes.default.func
};
var _default = Timer;
exports.default = _default;